































helpers = require('../../helpers.coffee')

view_model =
  components:
    businessesList: require('../businesses/list')
    newBusinessModal: require('../businesses/new_modal')

  data: ->
    current_user: Session.current_user
    filters: {}
    fetching: false
    next_page: true
    total_count: 0
    businesses: []

  methods:
    showCreateModal: ->
      jQuery("#new-business-modal").modal 'show'

    closeCreateModal: ->
      jQuery("#new-business-modal").modal 'hide'

    created: (business) ->
      @closeCreateModal()
      @updateBusinessList(business)
      
    updateBusinessList: (business) ->
      @businesses.unshift(business)

    leadsRedirect: ->
      @$router.push '/contatos/leads'

    businessRedirect: ->
      @$router.push '/contatos/empresas'

    groupsRedirect: ->
      @$router.push '/contatos/grupos'

    filter: (filters) ->
      @filters = filters
      @businesses = []
      @next_page = 1
      @loadData()

    loadData: ->
      return if @fetching || !@next_page
      @fetching = true
      @businesses_resource.index @loadSuccess, @unknownError,params: {q: @filters, page: @next_page}

    loadSuccess: (resources) ->
      @fetching = false
      @next_page = resources.meta.next_page
      @total_count = resources.meta.total_count
      @businesses = @businesses.concat(resources.businesses)
      Loader.off()

    showNabBars: ->
      !Session.current_user.new_ui

  mounted: ->
    @errors.clear()

  created: ->
    @businesses_resource = new BusinessesResource Session.current_company.id
    @loadData()

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/businesses.vue